/** @format */

import * as actionTypes from 'stateContainer/action-types';

export const loginRequestAction = (payload) => ({
  type: actionTypes.LOGIN_REQUESTED,
  payload
});

export const clearLoginStateAction = (payload) => ({
  type: actionTypes.CLEAR_LOGIN_STATE,
  payload
});

export const logoutRequestAction = () => ({
  type: actionTypes.LOGOUT_REQUESTED
});

export const updateActiveIndex = (payload) => ({
  type: actionTypes.ACTIVE_INDEX,
  payload
});

export const updateActiveIndexInfoCenter = (payload) => ({
  type: actionTypes.ACTIVE_INDEX_INFO_CENTER,
  payload
});

export const sendFriLansEmail = (payload) => ({
  type: actionTypes.SEND_FRILANCE_EMAIL_REQUESTED,
  payload
});

export const resetEmailReducer = (payload) => ({
  type: actionTypes.RESET_EMAIL_REDUCER,
  payload
});

export const fetchNotifications = (payload) => ({
  type: actionTypes.NOTIFICATIONS_REQUESTED,
  payload
});

/** broker profile related actions */

export const fetchBrokerProfile = (payload) => ({
  type: actionTypes.BROKER_PROFILE_REQUESTED,
  payload
});
export const fetchBrokerProfileBySlug = (payload) => ({
  type: actionTypes.BROKER_PROFILE_BY_SLUG_REQUESTED,
  payload
});

export const fetchBrokerObjects = (payload) => ({
  type: actionTypes.BROKER_OBJECTS_REQUESTED,
  payload: { profileId: payload }
});
export const fetchBrokerObjectsBySlug = (payload) => ({
  type: actionTypes.BROKER_OBJECTS_BY_SLUG_REQUESTED,
  payload: { profileSlug: payload }
});

export const fetchBrokerObject = (payload) => ({
  type: actionTypes.BROKER_OBJECT_REQUESTED,
  payload
});

export const fetchMoreBrokerObjects = (profileId, page) => ({
  type: actionTypes.MORE_BROKER_OBJECTS_REQUESTED,
  payload: { profileId, page }
});

export const fetchMoreBrokerObjectsBySlug = (profileSlug, page) => ({
  type: actionTypes.MORE_BROKER_OBJECTS_BY_SLUG_REQUESTED,
  payload: { profileSlug, page }
});

export const updateBrokerAction = (payload) => ({
  type: actionTypes.UPDATE_BROKER_REQUESTED,
  payload
});
